module.exports = __webpack_public_path__ + "media/videos/onboarding-73203c28.webm";